import axios from 'axios';
import {
  GET_CARDS,
  GET_TEMPLATE_CARDS,
  SAVE_CARDS,
  DELETE_CARD,
  UPDATE_CARD,
  ADD_CARD_SKILL,
  SET_CARD_SKILLS,
  UPDATE_CARD_SKILLS,
  DELETE_CARD_SKILL,
  HANDLE_PROJECTS,
} from '../types';

export function setCardTemplates(cardTemplates) {
  return {
    type: GET_TEMPLATE_CARDS,
    cardTemplates,
  };
}
export function setCards(cards) {
  return {
    type: GET_CARDS,
    cards,
  };
}
export function saveCards(card) {
  return {
    type: SAVE_CARDS,
    card,
  };
}
export function setDeleteCard(card) {
  return {
    type: DELETE_CARD,
    card,
  };
}
export function setUpdateCard(card) {
  return {
    type: UPDATE_CARD,
    card,
  };
}
export function setUpdateCardSkills(cardSkill) {
  return {
    type: UPDATE_CARD_SKILLS,
    cardSkill,
  };
}
export function setDeleteCardSkill(cardSkill) {
  return {
    type: DELETE_CARD_SKILL,
    cardSkill,
  };
}
export function setCardSkills(cardSkills) {
  return {
    type: SET_CARD_SKILLS,
    cardSkills,
  };
}

export function addCardSkill(cardSkill) {
  return {
    type: ADD_CARD_SKILL,
    cardSkill,
  };
}

export function getCardTemplates(wId, query) {
  return (dispatch) => {
    // return  axios.get("/bot/api/cardTemplates?"+query)
    return axios
      .get(`/bot/api/w/${wId}/jira/cardTemplates?` + query)
      .then((res) => {
        if (res.data.success) {
          dispatch(setCardTemplates(res.data.data));
        }
        return res;
      });
  };
}

export function getCards(wid, userId) {
  return (dispatch) => {
    // return  axios.get(`/bot/api/${wid}/cards/${userId}`)
    return axios.get(`/bot/api/w/${wid}/jira/cards/${userId}`).then((res) => {
      if (res.data.success) {
        dispatch(setCards(res.data.cards));
      }
      return res;
    });
  };
}

export function saveCard(wId, data) {
  return (dispatch) => {
    // return   axios.post("/bot/api/cardnodes",data)
    return axios.post(`/bot/api/w/${wId}/cardnodes`, data).then((res) => {
      if (res.data.success) {
        dispatch(saveCards(res.data));
      }
      return res;
    });
  };
}

export function deleteCard(wId, id) {
  return (dispatch) => {
    // return  axios.delete(`/bot/api/cards/${id}`)
    return axios.delete(`/bot/api/w/${wId}/cards/${id}`).then((res) => {
      if (res.data.success) {
        dispatch(setDeleteCard(res.data));
      }

      return res;
    });
  };
}

export function updateCard(wId, id, data) {
  return (dispatch) => {
    // return  axios.put(`/bot/api/cards/${id}`,data)
    return axios.put(`/bot/api/w/${wId}/jira/cards/${id}`, data).then((res) => {
      if (res.data.success) {
      }

      return res;
    });
  };
}

export function getCardSkills(wId, type, app, dontSaveInStore) {
  // Scope reports to the currently selected v2.1 team (default team also
  // includes legacy reports with no team).
  const teamId = localStorage.getItem('currentTeamId');
  const isDefault = localStorage.getItem('currentTeamIsDefault') === 'true';
  return (dispatch) => {
    let query = 'type=' + type;
    if (app) {
      query += '&app=' + app;
    }
    if (teamId) {
      query += `&teamId=${teamId}&isDefault=${isDefault}`;
    }
    // return axios.get("/bot/api/workspace/"+wId+"/getCardSkills?"+query)
    return axios
      .get('/bot/api/w/' + wId + '/jira/getCardSkills?' + query)
      .then((res) => {
        if (res.data.success && !dontSaveInStore) {
          dispatch(setCardSkills(res.data.CardSkills));
        }

        return res;
      });
  };
}

export function saveCardSkills(wId, data) {
  // Tag the new report with the currently selected v2.1 team.
  const currentTeamId = localStorage.getItem('currentTeamId');
  if (currentTeamId && data && !data.workspace_team_id) {
    data = { ...data, workspace_team_id: currentTeamId };
  }
  return (dispatch) => {
    // return   axios.post("/bot/api/addCardSkill",data)
    return axios
      .post(`/bot/api/w/${wId}/jira/addCardSkill`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(addCardSkill(res.data.cardSkill));
        }
        return res;
      });
  };
}
export function updateCardSkills(wId, data) {
  return (dispatch) => {
    // return axios.put(`/bot/api/updateCardSkill/${data._id}`,data)
    return axios
      .put(`/bot/api/w/${wId}/jira/updateCardSkill/${data._id}`, data)
      .then((res) => {
        if (res.data.success) {
          dispatch(setUpdateCardSkills(res.data.CardSkill));
        }
        return res;
      });
  };
}
export function checkTriggerPharse(wId, trigger, sid) {
  return (dispatch) => {
    let query = 'trigger=' + trigger;
    if (sid) {
      query += 'sId=' + sid;
    }
    // return   axios.get("/bot/api/"+id+"/checkTriggerPharse?"+query)
    return axios
      .get('/bot/api/w/' + wId + '/jira/checkTriggerPharse?' + query)
      .then((res) => {
        return res;
      });
  };
}

export function deleteCardSkill(wId, id) {
  return (dispatch) => {
    // return  axios.delete(`/bot/api/cardskill/${id}`)
    return axios
      .delete(`/bot/api/w/${wId}/jira/cardskill/${id}`)
      .then((res) => {
        if (res.data.success) {
          dispatch(setDeleteCardSkill(res.data.CardSkill));
        }

        return res;
      });
  };
}

export function getUserInfo(wId) {
  return (dispatch) => {
    // return   axios.get(`/bot/api/getUserInfo/${localStorage.getItem("trooprUserId")}`)
    return axios
      .get(
        `/bot/api/w/${wId}/user/info/${localStorage.getItem('trooprUserId')}`
      )
      .then((res) => {
        return res;
      });
  };
}

export function excecuteCardSkill(wId, id) {
  return (dispatch) => {
    // return   axios.get(`/bot/api/executeCardSkill/${id}`)
    return axios
      .get(`/bot/api/w/${wId}/jira/executeCardSkill/${id}`)
      .then((res) => {
        return res;
      });
  };
}

export const handleSelectedProject = (projects) => {
  return {
    type: HANDLE_PROJECTS,
    selectedProjectsForReport: projects,
  };
};
